<p>charts-landing works!</p>
<div id="chart"></div>
...